import { Box, Divider, Typography } from "@mui/material";
import React from "react";

import HomeIcon from '@mui/icons-material/Home';
import PlaceIcon from '@mui/icons-material/Place';
import PhoneIcon from '@mui/icons-material/Phone';
import theme from "../../utils/theme";
import TikTok from "../../assets/images/tiktok-icon.svg"
import { Link } from "react-router-dom";

const shopInfoList = [
    {
        name: 'Super Mobile Mandalay',
        address: 'No.(B-1,2,3), 7th Street, Between 27th & 28th Streets, Chanayethazan Township, Mandalay.',
        phone: '09-423368881, 02-4066884',
        tiktok: 'TikTok Acc - @supermobilemdy',
        link: 'https://www.tiktok.com/@supermobilemdy',
    },
    {
        name: 'Super Mobile Yangon',
        address: 'Room (201-A1), No. (192), 2nd Floor, Myanmar Plaza, Kabaraye Pagoda Road, Yankin Township, Yangon',
        phone: '09-448490007, 09-452352555',
        tiktok: 'TikTok Acc - @supermobileygn',
        link: 'https://www.tiktok.com/@supermobileygn',
    }
]

const ShopInfo = () => {
    return (
        shopInfoList.map((shop, index) => (
            <Box
                key={index}
                sx={{
                    display: 'flex',
                    pb: '50px'
                }}
            >
                <Box>
                    <Box sx={{
                        display: 'flex'
                    }}>
                        <HomeIcon sx={{
                            color: theme.palette.primary.main,
                            mr: '10px'
                        }} />
                        <Typography sx={{
                            fontSize: theme.palette.Content.fontSize,
                            fontWeight: 'bold'
                        }}>{shop.name}</Typography>
                    </Box>
                    <Box height='10px' />
                    <Box sx={{
                        display: 'flex'
                    }}>
                        <PlaceIcon sx={{
                            color: theme.palette.primary.main,
                            mr: '10px'
                        }} />
                        <Typography>{shop.address}</Typography>
                    </Box>
                    <Box height='10px' />
                    <Box sx={{
                        display: 'flex'
                    }}>
                        <PhoneIcon sx={{
                            color: theme.palette.primary.main,
                            mr: '10px'
                        }} />
                        <Typography>{shop.phone}</Typography>
                    </Box>
                    <Box height='10px' />
                    <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                    >
                        <img src={TikTok} alt="" width="24px" height="24px" />
                        <Link to={shop.link} target="_blank" style={{ textDecoration: 'none' }}>
                            <Typography component="div">
                                <Box sx={{ fontWeight: 500, m: 1, color: '#1972F2' }}>{shop.tiktok}</Box>
                            </Typography>
                        </Link>
                    </Box>
                </Box>
                {
                    index < shopInfoList.length - 1 && ((
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{
                                height: '100%',
                                mx: '5px',
                                bgcolor: '#4d4d4d',
                                borderRightWidth: 3
                            }}
                        />
                    ))
                }
            </Box>
        ))
    )
}

export default ShopInfo